import { render, staticRenderFns } from "./Complications.vue?vue&type=template&id=46b217b1"
import script from "./Complications.vue?vue&type=script&lang=js"
export * from "./Complications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports